<template>
    <div>

        <el-card v-if="vista == 'login'" class="card-login" shadow="always" :body-style="{ padding: '20px' }">
            <h2 class="pt-sans-bold">Espacio de formación personal</h2>
            <div>

                <p>
                    Desde aquí podrá administrar sus inscripciones, acceder a las aulas virtuales y conocer
                    el estado de sus trayectos formativos.
                </p>

                <el-form :model="form" ref="form" :label-position="'top'" class="login" label-width="80px"
                    :inline="false" size="normal">
                    <el-form-item label="Cuil (sin guiones)" prop="cuil" :rules="[
            {
                required: true,
                message: 'campo obligatorio',
                trigger: 'blur',
            },
        ]">
                        <el-input v-mask="'############'" v-model="form.cuil"></el-input>
                    </el-form-item>
                    <el-form-item label="Contraseña" prop="pass" :rules="[
            {
                required: true,
                message: 'campo obligatorio',
                trigger: 'blur',
            },
        ]">
                        <el-input show-password v-model="form.pass"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="azul" class="btn-100" :loading="cargando" @click="loguear">Acceder</el-button>

                        <a v-if="!cargando" href="#" target="_blank" rel="noopener noreferrer" @click.prevent="vista = 'recuperar'"
                            style="float:right">Recuperar
                            contraseña</a>

                    </el-form-item>
                    <div class="login-msj">
                        Si usted contaba con un usuario en <strong>Panel Docente</strong> utilícelos para acceder o
                        recuperar contraseña.
                        <br>
                        Si no contaba con un usuario deberá registrarse
                        <br>
                        <el-button type="gris" class="btn-100" :disabled="cargando ? true :false" size="small" @click="vista = 'registro'">Quiero
                            registrarme</el-button>

                    </div>
                </el-form>


            </div>



        </el-card>

        <registro v-if="vista == 'registro'" />

        <recuperar v-if="vista == 'recuperar'" />

    </div>
</template>

<script>
import { HTTP  } from "@/axios"
import { EventBus } from "@/event-bus"
import registro from "@/components/registro"
import recuperar from "@/components/recuperar"
import deviceInfoMixin from '@/mixins/deviceInfoMixin'
    export default {
        mixins: [deviceInfoMixin],
        components:{
            registro,
            recuperar
        },
    data() {
        return {
            form: {},
            vista: 'login',
            cargando:false,
        }
    },
    mounted() {
        if (this.$route.query && this.$route.query.vista && this.$route.query.vista == 'recuperaPass') {
            // this.$message.error('Error, Los datos son incorrectos.')
            this.vista = 'recuperar'
        }
    },
        created()
        {
            console.log("this.$route.query", this.$route.query)
            if (this.$route.query && this.$route.query.vista && this.$route.query.vista == 'recuperaPass') {
                // this.$message.error('Error, Los datos son incorrectos.')
                this.vista = 'recuperar'
            }
            EventBus.$on('CancelarRe', (r) => {
                this.vista = r
            })

            EventBus.$on('IngresarExt',(f) => { 
                this.form.cuil = f.cuil
                this.form.pass = f.pass 
                setTimeout(() => {
                    this.loguear()
                }, 100);
            })
        },
        methods: {
            loguear() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.cargando = true
                        this.form.ip_cliente = this.deviceInfo.ip_cliente
                        this.form.dispositivo_cliente = this.deviceInfo.dispositivo_cliente
                        HTTP.post('/docente/loguear', this.form)
                            .then(res => {
                                if(res.data) {
                                    window.sessionStorage.setItem('userData', JSON.stringify(res.data))
                                    setTimeout(() => {
                                        this.cargando = false
                                        if (this.$route.query && this.$route.query.accion)
                                        {
                                            this.$router.push({ name: 'cambiar-password-force' })
                                            // this.$router.push({ name: 'homeDocente' })res.data.force_pass

                                        }
                                        else{
                                            this.$router.push({ name: 'homeDocente' })
                                        }
                                        
                                    }, 60);
                                } else {
                                    this.cargando = false
                                    this.$alert('No pudimos validar sus datos','ERROR AL PROCESAR SUS DATOS', { type: 'error' })
                                }
                            })
                            .catch((e) => {
                                this.cargando = false
                                let mensaje = e.response?.data.error+ ' verifique sus datos y reintente nuevamente.' || 'No pudimos procesar su solicitud.';
                                let titulo = e.response?.data ? 'ERROR' : 'ERROR DE SERVIDOR';
                                this.$alert(mensaje, titulo, { type: 'error' })
                            })
                    } else {
                        return false
                    }
                })
            }
        },
       
    }
</script>
<style>
  .transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
</style>
<style lang="scss" scoped>
 .card-login{
    margin-top: 80px;
    min-height: 610px;
 }
  .card-login h2{
    text-align: center;
    text-transform: uppercase;
    // margin: 0;
    font-size: 20px;
  }
  .card-login p{
    text-align: center;
    font-size: 14px;
  }

  .login{
    width:250px;
    margin: 20px auto;
  }

  .login-msj{
    font-size: 14px;
    padding: 10px;
border: 1px solid #ef9a9a75;
    background: #ffebee70;
    border-radius:4px;
  }
  @media screen and (max-width: 992px) {
.card-login {
    padding-top: 20px;
        margin-top: 0px;
       
    }

    

  }
</style>